/**
 * Largura de cada card de Potência Ativa (em colunas de 12) por breakpoint. Fonte única para o Grid
 * dos cards e para o cálculo de colunas usado no deslocamento dos cards abaixo do hint. SGD-3839.
 */
export const ACTIVE_POWER_CARD_SPAN = {xs: 12, md: 6, lg: 4, xl: 4} as const;

export type ActivePowerCardBreakpoint = keyof typeof ACTIVE_POWER_CARD_SPAN;

const GRID_COLUMNS = 12;

export const getActivePowerColumnCount = (breakpoint: ActivePowerCardBreakpoint): number =>
    GRID_COLUMNS / ACTIVE_POWER_CARD_SPAN[breakpoint];

/**
 * Indica se o card na posição `index` deve descer enquanto o hint do card `openHintIndex` está aberto:
 * só os cards depois dele e na mesma coluna (o Grid preenche as linhas da esquerda para a direita).
 */
export const isShiftedByOpenHint = (index: number, openHintIndex: number, columnCount: number): boolean =>
    openHintIndex >= 0 && index > openHintIndex && index % columnCount === openHintIndex % columnCount;
